import React from "react";
import styled from "styled-components";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

function GenericError({ errorMassege }) {
    return (
        <AlertWrapper>
            {Object?.keys(errorMassege)?.map((key) => (
                <TitleWrapper key={key}>
                    <ReportProblemOutlinedIcon
                        color="error"
                        fontSize="16px"
                    />
                    <Title>
                        {key}: {errorMassege[key]}
                    </Title>
                </TitleWrapper>
            ))}
        </AlertWrapper>
    );
}
const AlertWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
`;
const TitleWrapper = styled.div`
    display: flex;
    color: #bd271e;
    margin-bottom: 10px;
    align-items: center;
    background: #f8e9e9;
    gap: 9px;
    padding: 16px;
`;
const Title = styled.p`
    color: #bd271e;
    font-weight: 500;
    font-size: 16px;
    margin-block: 5px;
`;

export default GenericError;
